module.exports = "//cdn-staging.livechat-static.com/webapp/img/helpdesk-in-livechat/start-trial-graphic.png?1d6e8655d0be19dae99b9a09e6471070";